// Values for all variables here should match with values in _variables.scss.

/* prettier-ignore */
const brandColors = {
  pedestalBlue: '#73f0e9',
  blue2: '#0fb5d2',
  blue3: '#0888ab',
  blue4: '#4166ff',
  darkBlue: '#140298',
  lightGray: '#f0f0f0',
  white: '#ffffff',
  yellow: '#e0ff45',
  green: '#c6db0a',
  darkGreen: '#495102',
  mediumGray: '#acacac',
  darkGray: '#575757',
  pink: '#f16cb9',
  orange: '#fd8524',
  red: '#a5052d'
}

// Subtler ramps of each hued brand color — six progressively less saturated
// alternatives for cases where the primary brand color reads as too vivid.
// Index 0 is closest to the original; index 6 is the most muted.
/* prettier-ignore */
const brandColorRamps = {
  pedestalBlue: ['#73f0e9', '#7ce7e1', '#86ddd8', '#8fd4d0', '#97ccc9', '#9fc4c2', '#a6bdbb'],
  blue2: ['#0fb5d2', '#1eabc3', '#2ca0b5', '#3b96a6', '#488d99', '#53858e', '#5f7d82'],
  blue3: ['#0888ab', '#14819f', '#207a93', '#2d7386', '#376d7c', '#416772', '#4b6268'],
  blue4: ['#4166ff', '#4f60f1', '#5e6be2', '#6c77d4', '#7880c8', '#8489bc', '#8f92b1'],
  darkBlue: ['#140298', '#1d0d90', '#261984', '#2e2479', '#362e6f', '#3d3865', '#44415c'],
  yellow: ['#e0ff45', '#d7f153', '#cde361', '#c4d56f', '#bcc97b', '#b5be86', '#adb391'],
  green: ['#c6db0a', '#b9cb1a', '#adbc29', '#a0ac39', '#969e47', '#8c9253', '#828560'],
  darkGreen: ['#495102', '#444b08', '#40450e', '#3b3f14', '#373a19', '#33351e', '#2f3122'],
  pink: ['#f16cb9', '#e776b7', '#dd80b6', '#d38ab4', '#ca93b3', '#c29bb2', '#baa3b0'],
  orange: ['#fd8524', '#ed8734', '#dc8845', '#cc8a55', '#be8c63', '#b18d70', '#a48e7d'],
  red: ['#a5052d', '#991133', '#8d1d39', '#81293f', '#773344', '#6d3d49', '#63474e']
}

export const colors = {
  // colors
  font: 'var(--theme-font)',
  fontAlt: 'var(--theme-font-alt)',
  navbarColor: 'var(--theme-navbar-bg)',
  border: 'var(--theme-border)'
}

const lum = 1
export const chartColors = [
  brandColorRamps.orange[lum],
  brandColorRamps.blue4[lum],
  brandColorRamps.pink[lum],
  brandColorRamps.green[lum],
  brandColorRamps.yellow[lum],
  brandColorRamps.red[lum],
  brandColorRamps.blue2[lum],
  brandColorRamps.darkGreen[lum],
  brandColorRamps.blue4[lum],
  brandColors.darkGray
]

export const classicChartColors = [
  '#d55e00',
  '#0072b2',
  '#cc79a7',
  '#009e73',
  '#f0e442',
  '#911f12',
  '#56b4e9',
  '#e69f00',
  '#92e0b3',
  '#333333'
]

export const sizes = {
  pageHeaderHeight: '80px',
  buttonHeight: '32px',
  textInputHeight: '42px',
  formElementPadding: '16px',
  formElementMediumPadding: '10px',
  navHeight: '48px'
}

export const zIndexes = {
  layoutSidebar: 1,
  chartExportCanvas: 1,
  sideBySideChartFilterBar: 1,
  filterSelectSeparator: 1,
  layoutContent: 2,
  sideBySideChartRight: 3,
  chartLoader: 3,
  editableBlockActionsArea: 3,
  sideBySideChartLeft: 3,
  scrollContent: 4,
  blockConfirmation: 4,
  pageHeader: 8,
  pageControlBar: 9,
  dropdownMenuOverlay: 10,
  inputMessageTooltip: 10,
  chartTooltip: 10,
  dropdownMenu: 11,
  executiveSummaryFullReportLink: 19,
  modalOverlay: 20,
  modal: 21,
  navbar: 40
}

export const fonts = {
  barlow: '"Barlow", san-serif',
  raleway: '"Chivo", sans-serif',
  lato: '"Lato", sans-serif'
}

export const boxShadows = {
  card: '0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12)',
  hover: '0 8px 16px 0 rgba(0,0,0,0.2)',
  splitLayoutContent:
    '0 0 10px rgba(0, 0, 0, 0.1), 5px 5px 10px rgba(0, 0, 0, 0.1)',
  subLayerBefore: '0 0 5px rgb(0, 0, 0, 0.3), 5px 5px 10px rgb(0, 0, 0, 0.3)',
  subLayerAfter: '0 0 5px rgb(0, 0, 0, 0.3), -5px -5px 10px rgb(0, 0, 0, 0.3)'
}

export const styleFragments = {
  baseHeaderFont: {
    fontFamily: "'Chivo', sans-serif",
    fontVariantNumeric: 'lining-nums',
    margin: '0',
    letterSpacing: '0.02em'
  },
  baseBodyFont: {
    fontFamily: "'Instrument Sans', sans-serif",
    letterSpacing: '0.03em'
  }
}
